import React from 'react'
import { NavLink } from 'react-router-dom'

export default function SidebarElement({title,badge,SVG,link}) {
    let classes = "flex px-4 py-2"
    return (
        <li className="font-semibold mt-2">
        <NavLink to={link} activeClassName="active" className={link !== "/logout" ? classes : "flex px-4 mt-0 md:mt-80"}>
            {SVG}
            <span  className="text-xs lg:text-sm text-gray-500 ">{title}</span>
        </NavLink>
    </li>
    )
}
